module.exports = __webpack_public_path__ + "static/media/logo-spin.511f76f6.svg";